<template>
  <div class="page-container">
    <!--首页内容-->
    <div class="container pt-200">
      <!--面包屑导航-->
      <Breadcrumb :breadcrumbList="['商务阅读平台']"></Breadcrumb>
      <div class="booktopcon flex">
        <div class="left">
          <Sidenav :navicon="navicon" :navlist="navlist" type="3" @getnav="getnav"></Sidenav>
        </div>
        <div class="right ml-30">
          <!--轮播图-->
          <Slider :bannerphoto="bannerphoto" :type="2"></Slider>
        </div>
      </div>
      <div class="recommendcon flex jc-betweet">
        <div class="conleft">
          <div class="title flex jc-betweet ai-center">
            <div class="fs-32 color-black">
              PDF文档推荐<span class="fs-28 color-fontcol6 fstyle-italic"
                >/PDF Document Recommendation</span
              >
            </div>
            <div class="point fs-24 color-fontcol8" @click="jumpmore(1)">more</div>
          </div>
          <div class="con flex flex-w">
            <Readbox :list="newBookData" :cols="3"></Readbox>
          </div>
        </div>
        <div class="conright">
          <div class="title ml-40">
            <div class="fs-32 color-black">
              排行榜<span class="fs-28 color-fontcol6 fstyle-italic">/Ranking List</span>
            </div>
            <div class="con mt-30 pb-30">
              <li
                class="point"
                v-for="(item, index) in ranklist"
                :key="index"
                @click="toDetail(server + item.pdfUrl)"
                @mouseenter="choserank(index)"
              >
                <div
                  class="modelactive mt-30 flex flex-w jc-betweet animated pulse"
                  v-if="item.isactive"
                >
                  <div
                    class="rank bg-cole54 text-center color-white fs-16"
                    v-if="index < 3"
                  >
                    {{ index < 9 ? "0" : "" }}{{ index + 1 }}
                  </div>
                  <div class="rank2 color-fontcol3 fs-16 text-center" v-else>
                    {{ index < 9 ? "0" : "" }}{{ index + 1 }}
                  </div>
                  <img
                    class="img mt-20"
                    :src="'http://www.cctpress.com/file/' + item.cover"
                    alt=""
                  />
                  <div class="info mt-25">
                    <div class="name fs-18 color-fontcol3 text-ellipsis2">
                      {{ item.bookTitle }}
                    </div>
                    <div class="actor mt-10 fs-16 color-fontcol3">
                      {{ item.author }}
                    </div>
                    <div class="price mt-10 fs-16 color-cole54">￥{{ item.price }}</div>
                  </div>
                </div>
                <div class="model flex jc-betweet ai-center" v-if="!item.isactive">
                  <div
                    class="rank bg-cole54 text-center color-white fs-16"
                    v-if="index < 3"
                  >
                    {{ index < 9 ? "0" : "" }}{{ index + 1 }}
                  </div>
                  <div class="rank2 color-fontcol3 fs-16 text-center" v-else>
                    {{ index < 9 ? "0" : "" }}{{ index + 1 }}
                  </div>
                  <div class="tit color-fontcol6 fs-18 text-ellipsis">
                    {{ item.bookTitle }}
                  </div>
                  <div class="price color-fontcol6 fs-16">￥{{ item.price }}</div>
                </div>
              </li>
              <!-- <div
                class="more mt-20 pb-10 fs-18 color-fontcol6 text-center"
                @click="jumpmore(2)"
              >
                更多 >
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Slider from "../components/common/swiper";
import Breadcrumb from "../components/common/breadcrumb";
import Sidenav from "../components/common/sidenav";
import Readbox from "../components/common/readbox";
export default {
  name: "about",
  components: {
    Breadcrumb,
    Slider,
    Sidenav,
    Readbox,
  },
  data() {
    return {
      server: "http://www.cctpress.com/file/",
      choseid: 0, //选中的导航id
      navlist:[],//
      navicon: [
        {
          img: require("../assets/image/booknav1.png"),
          imgactive: require("../assets/image/booknav1active.png"),
        },
        {
          img: require("../assets/image/booknav2.png"),
          imgactive: require("../assets/image/booknav2active.png"),
        },
        {
          img: require("../assets/image/booknav3.png"),
          imgactive: require("../assets/image/booknav3active.png"),
        },
        {
          img: require("../assets/image/booknav4.png"),
          imgactive: require("../assets/image/booknav4active.png"),
        },
        {
          img: require("../assets/image/booknav5.png"),
          imgactive: require("../assets/image/booknav5active.png"),
        },
        {
          img: require("../assets/image/booknav6.png"),
          imgactive: require("../assets/image/booknav6active.png"),
        },
        {
          img: require("../assets/image/booknav7.png"),
          imgactive: require("../assets/image/booknav7active.png"),
        },
        {
          img: require("../assets/image/booknav8.png"),
          imgactive: require("../assets/image/booknav8active.png"),
        },
      ], //导航列表
      bannerphoto: [], //轮播图
      newBookData: [], //新书推荐
      newbookid: 0, //新书推荐的id
      ranklist: [],
    };
  },
  mounted() {
    this.getnavlist();
    this.loadBanner();
    //获取新书推荐列表
    this.getnewbook();
    //获取图书排行
    this.getbookrank();
  },
  methods: {
    //导航跳转
    getnav(msg) {
       var id= this.navlist[msg].id;
       var idname= this.navlist[msg].name;
       this.$router.push({path:'/pdfSearch?id='+id+'&idname='+idname});
    },
    //查询侧边导航
    async getnavlist() {
      var res = await this.$API.API_Ajax("侧面导航列表", {
        type: this.CONSTANT.getDateByCode("reading_id").id,
      });
      if (res.code == 200) {
        this.navlist = res.data.splice(0,4);
      }
    },
    //查询轮播
    async loadBanner() {
      var res = await this.$API.API_Ajax("轮播图接口", {
        type: this.CONSTANT.getDateByCode("reading_book").id,
      });
      if (res.code == 200) {
        this.bannerphoto = res.data;
      }
    },
    //查询新书推荐列表
    async getnewbook() {
      var params = {
        pageNum: "1",
        pageSize: "6",
      };
      var res = await this.$API.API_Ajax("PDF文档推荐", params);
      if (res.code == 200) {
        var list = res.data.list;
          list.map((item) => {
            if(item.time){
                item.time = this.$moment(new Date(item.createTime.time).getTime()).format(
                    "YYYY.MM"
                );
            }
        });
        this.newBookData = list;
      }
    },
    //获取排行
    async getbookrank() {
      var res = await this.$API.API_Ajax("PDF排行榜");
      if (res.code == 200) {
        var list = res.data;
        list.map((item, index) => {
          item.isactive = false;
          if (index == 0) {
            item.isactive = true;
          }
        });
        this.ranklist = list;
      }
    },
    toDetail(url) {
      window.open(url, "_blank");
    },
    //新书推荐选中状态
    chosenewbook(index) {
      this.newbookid = index;
    },
    //排行榜
    choserank(index) {
      this.ranklist.map((item, idx) => {
        if (index == idx) {
          item.isactive = true;
        } else {
          item.isactive = false;
        }
      });
    },
    //更多跳转
    jumpmore(id) {
      this.$router.push({ path: "/pdfList", query: {} });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-container {
  width: 100%;
  height: auto;
  margin: auto;
  .booktopcon {
    width: 65%;
    height: 100%;
    margin: auto;
    margin-top: 90px;
    .left {
      width: 250px;
      height: 100%;
      background: #ffffff;
    }
    .right {
      width: 1000px;
      height: 100%;
      background: #ffffff;
      .advertisement {
        width: 1000px;
        img {
          width: 489px;
          height: 200px;
        }
      }
    }
  }
  .recommendcon {
    width: 65%;
    margin: auto;
    margin-top: 50px;
    margin-bottom: 90px;
    .conleft {
      width: 840px;
    }
    .conright {
      width: 400px;
      .con {
        width: 380px;
        border: 1px solid #e8e8e8;
        border-top: 3px solid #ee544b;
        .modelactive {
          width: 95%;
          height: 160px;
          margin: auto;
          margin-top: 20px;
          .rank {
            width: 34px;
            height: 34px;
            line-height: 34px;
            border-radius: 50%;
          }
          .rank2 {
            width: 34px;
            height: 34px;
            line-height: 34px;
          }
          .img {
            width: 90px;
            height: 124px;
          }
          .info {
            width: 180px;
            .name {
              width: 100%;
              height: 50px;
            }
            .actor {
              width: 100%;
            }
            .price {
              width: 100%;
            }
          }
        }
        .model {
          width: 95%;
          height: 35px;
          margin: auto;
          margin-top: 20px;
          .rank {
            width: 34px;
            height: 34px;
            line-height: 34px;
            border-radius: 50%;
          }
          .rank2 {
            width: 34px;
            height: 34px;
            line-height: 34px;
          }
          .tit {
            width: 225px;
          }
        }
        .more {
          width: 100%;
          height: 40px;
          line-height: 51px;
          border-top: 1px solid #e8e8e8;
        }
      }
    }
  }
}
</style>
